import {
    AD_SLOT_INTERSTITIAL_CONSUMED,
    AD_SLOT_INTERSTITIAL_PREPARED,
    AdSlotInterstitialConsumedAction,
    AdSlotInterstitialPreparedAction,
} from 'mk2/containers/AdSlotInterstitial/AdSlotInterstitial.actions';
import { tupdate } from 'mk2/helpers/types';
import { Reducer } from 'redux';

export interface AdSlotInterstialState {
    isLoaded: boolean;
}

export const initialAdSlotInterstialState = {
    isLoaded: false,
};

type AdSlotInterstitialActions =
      AdSlotInterstitialConsumedAction
    | AdSlotInterstitialPreparedAction;

export const adSlotInterstitialReducer: Reducer<AdSlotInterstialState> =
    (state = initialAdSlotInterstialState, action: AdSlotInterstitialActions) => {

    switch (action.type) {
        case AD_SLOT_INTERSTITIAL_PREPARED:
            return tupdate(state, {
                isLoaded: true,
            });

        case AD_SLOT_INTERSTITIAL_CONSUMED:
            return tupdate(state, {
                isLoaded: false,
            });

        default:
            return state;
    }
};
